import SelectEnumFilter, { SelectEnumFilterOption } from '../SelectEnumFilter/SelectEnumFilter';

export interface SelectNumberFilterOption extends SelectEnumFilterOption { }
const SelectNumberFilter = SelectEnumFilter
export default SelectNumberFilter
